import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import "reactjs-popup/dist/index.css";
import { addBarcodeToProduct } from "../../services/assortiment/actions";
import "./Scanner.scss";

const usePropChangeEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line
  }, deps);
};

function ScannerAdd(props) {
  const location = useLocation();
  const { from } = location.state;
  const [data, setData] = React.useState("Not Found");

  const [currentLocation, setCurrentLocation] = React.useState(
    props.currentLocation
  );

  usePropChangeEffect(() => {
    setCurrentLocation(props.currentLocation);
  }, [props.currentLocation]);

  return (
    <>
      <BarcodeScannerComponent
        width={"100%"}
        height={"100%"}
        onUpdate={(err, result) => {
          if (result) {
            setData(result.text);
            props.addBarcodeToProduct(from.id, result.text);
          }
        }}
      />
    </>
  );
}

function mapStateToProps(state) {
  return {
    currentLocation: state.currentInformation.current_location,
  };
}

export default connect(mapStateToProps, { addBarcodeToProduct })(ScannerAdd);
